<template>
  <div class="simple-banner mt-8">
        <a href="/" class="simple-banner__link">
            <img src="https://cf.shopee.co.th/file/sg-11134252-7rd64-lwif249wlktb85" class="simple-banner__img">
        </a>
    </div>
</template>

<script>
export default {
    name: 'Mutil-SimpleBanner'
}
</script>

<style>

</style>